import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { NonMasteredUserModalProps } from './NonMasteredUserModal.tsx';

export const NonMasteredUserModalLoader: LoadableType<NonMasteredUserModalProps> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-NonMasteredUserModal" */ './NonMasteredUserModal.tsx'
			)
		).NonMasteredUserModal,
});
